import {uniqueId} from 'lodash'
import {visaOwnerType, contractType, visaStatus} from '@/constants/companyVisas'
import {UNDER_RENEWAL} from '@/constants/expireStatus'
import countriesList from '@/constants/countriesList'

const columns = [
  {
    name: 'Investor name',
    prop: 'visaOwnerName',
    type: 'string',
    ownerType: visaOwnerType.investor,
    inputFocus: true
  },
  {
    name: 'Employee Name',
    prop: 'visaOwnerName',
    type: 'string',
    ownerType: visaOwnerType.employee
  },
  {
    name: 'Salary',
    prop: 'visaOwnerSalary',
    type: 'string',
    format: 'number'
  },
  {
    name: 'Citizenship',
    prop: 'citizenship',
    type: 'countries',
    options: countriesList,
    width: 'minmax(150px, 1fr)'
  },
  {
    name: 'Contract Type',
    prop: 'contractType',
    type: 'select',
    options: contractType,
    ownerType: visaOwnerType.employee,
    width: 'minmax(100px, 1fr)'
  },
  {
    name: 'Contract Dates',
    prop: 'contractDates.start',
    range: 'contractDates',
    type: 'date',
    dateType: 'contractType',
    ownerType: visaOwnerType.employee,
    width: 'minmax(200px, 1fr)'
  },
  {
    name: 'Visa Exp Date',
    prop: 'visaExpDate',
    type: 'date',
    disabled: {
      prop: 'expireStatus',
      noEqual: UNDER_RENEWAL.id
    },
    width: 'minmax(135px, 1fr)'
  },
  {
    name: 'Status',
    prop: 'visaStatus',
    type: 'select',
    options: visaStatus,
    width: 'minmax(130px, 1fr)'
  },
  {
    prop: 'uploadFile',
    type: 'file',
    width: '25px'
  }
]

const prefix = 'contacts_visas_column_'
const contactsVisasTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export {contactsVisasTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactsVisasTable.js